import React from "react";
import WorkExperience from "../../views/WorkExperience";

const WorkExperiencePage = () => {
  return <WorkExperience />;
};

export default WorkExperiencePage;
